import { styled } from '@mui/material';
import { PopoverArrow } from '@procureai/ui-mui';

const ITEM_HEIGHT = 48;

export const PopoverArrowStyled = styled(PopoverArrow)({
  pointerEvents: 'none',
  '& > *': {
    pointerEvents: 'auto',
  },
});

export const Content = styled('div')({
  maxHeight: ITEM_HEIGHT * 5.5,
  overflow: 'auto',
});
